import { ApiService } from 'src/app/services/api/api.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UserVideoServices {
  private baseUrl = environment.base_url;

  constructor(
    private http: HttpClient,
    private ApiService: ApiService
  ) { }

  getVideoDetail(id): Observable<any> {
    if(this.isUserLoggedIn()){
      return this.ApiService.get(`user-videos/${id}`);
    }else{
      return this.http.get(`${this.baseUrl}user-videos/${id}`);
    }
  }

  getAccountVideos(userId): Observable<any> {
    // return this.http.get<any>(this.baseUrl + `users/getUserVideos`);
    return this.ApiService.get(`users/getUserVideos/`+userId);
  }

  isUserLoggedIn(){
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    }else{
      return false;
    }
  }

}
